import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ErrorsService } from '@app/_shared/errors/errors.service';
import { AppService } from '@app/app.service';
import { IsUndefinedOrNull } from '@app/common_helper';
import { ProductService } from '@products/product/product.service';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'facnm-product-popup',
  templateUrl: './product-popup.component.html',
  styleUrls: ['./product-popup.component.scss']
})
export class ProductPopupComponent implements OnInit {


  @Output() popupCancel: EventEmitter<any> = new EventEmitter();
  @Output() popupOk: EventEmitter<any> = new EventEmitter();
  @ViewChild('dataGrid', { static: true }) dataGrid: DxDataGridComponent;

  constructor(
    private product$: ProductService,
    private errors$: ErrorsService,
    private ngxSmartModalService: NgxSmartModalService,
    private app$: AppService,
  ) { }

  filterOptions = {
    ProductNumber: null, ProductName: null, ProductGroup: null, QuantityUnit: null, ProductTypeId: null,
    GridPagerOptions: { PageIndex: 0, PageSize: 20, TotalPages: null }
  };
  PageSize = 20;
  TotalCount = null;
  customDataSource: any;
  productType: any;
  productCategories: any;

  ngAfterViewInit() {
    this.ngxSmartModalService.open('modal');
    this.app$.notifyScreenBusy();
  }
  ngOnInit(): void {
    this.getCustomDataSource();
    forkJoin({
      categoryList: this.product$.getProductCategoryList(),
      productTypeDropdown: this.product$.getProductTypeDropdown(),
    }).subscribe(
      res => {
        this.productType = res['categoryList'];
        this.productCategories = res['productTypeDropdown'];
        this.app$.notifyScreenReady();
      },
      (errorNetwork) => {
        this.errors$.handleServerErrors(errorNetwork);
      }
    );

  }

  getCustomDataSource() {
    this.customDataSource = new CustomStore({
      key: ['Id'],
      load: (loadOptions) => {
        if (loadOptions != undefined) {
          this.filterOptions.ProductNumber = null;
          this.filterOptions.ProductName = null;
          this.filterOptions.ProductGroup = null;
          this.filterOptions.QuantityUnit = null;
          this.filterOptions.ProductTypeId = null;
          if (loadOptions.filter != undefined) { // accessing grid filter values    
            if (loadOptions.filter.length) {
              if (!Array.isArray(loadOptions.filter[0])) {
                let filter = loadOptions.filter;
                loadOptions.filter = [];
                loadOptions.filter.push(filter);
              }
            }
            for (var i = 0; i < loadOptions.filter.length; i++) {
              if (loadOptions.filter[i].length == 3) {
                if (loadOptions.filter[i][0] == "ProductNumber") this.filterOptions.ProductNumber = loadOptions.filter[i][2];
                else if (loadOptions.filter[i][0] == "ShortProductName") this.filterOptions.ProductName = loadOptions.filter[i][2];
                else if (loadOptions.filter[i][0] == "ProductCategoryId") this.filterOptions.ProductGroup = loadOptions.filter[i][2];
                else if (loadOptions.filter[i][0] == "QuantityUnit") this.filterOptions.QuantityUnit = loadOptions.filter[i][2];
                else if (loadOptions.filter[i][0] == "ProductTypeId") this.filterOptions.ProductTypeId = loadOptions.filter[i][2];
              }
            }
          }
          this.filterOptions.GridPagerOptions.PageSize = (IsUndefinedOrNull(loadOptions.take) == true) ? this.PageSize : loadOptions.take;
          this.filterOptions.GridPagerOptions.PageIndex = ((IsUndefinedOrNull(loadOptions.take) && IsUndefinedOrNull(loadOptions.skip)) == true) ? 0 : (loadOptions.skip / loadOptions.take);
        }
        return this.product$.getList(this.filterOptions)
          .toPromise()
          .then((response: any) => {
            return {
              data: response.ProductListVM,
              totalCount: response.TotalCount,
            };
          })
          .catch((errorNetwork) => this.errors$.handleServerErrors(errorNetwork));
      }
    });
  }

  onContentReady(e) {
    this.dataGrid.noDataText = this.dataGrid.instance.totalCount() ? '' : "No Products Found";
  }

  onPopupCancel() {
    this.ngxSmartModalService.close('modal');
    this.popupCancel.emit();
  }
  onPopupOk() {
    this.ngxSmartModalService.close('modal');
    this.popupOk.emit(this.dataGrid.instance.getSelectedRowsData());
  }

}
